/**
 * Utility functions for drag and drop operations in charlie-table
 */

export type IsDropAllowedProps = {
	sourceColumnId: string;
	targetColumnId: string;
	columnPinning?: { left?: string[]; right?: string[] };
};

/**
 * Determines if a column drop is allowed based on pinning constraints.
 * Left-pinned columns can only be dropped on other left-pinned columns.
 * Unpinned columns cannot be dropped on left-pinned columns.
 */
export const isDropAllowed: (props: IsDropAllowedProps) => boolean = ({
	sourceColumnId,
	targetColumnId,
	columnPinning,
}: IsDropAllowedProps) => {
	if (sourceColumnId === targetColumnId) {
		return true;
	}

	const isSourceLeftPinned = columnPinning?.left?.includes(sourceColumnId);
	const isTargetLeftPinned = columnPinning?.left?.includes(targetColumnId);

	// Left-pinned columns can only be dropped on other left-pinned columns
	if (isSourceLeftPinned) {
		return isTargetLeftPinned ?? false;
	}

	// Unpinned columns cannot be dropped on left-pinned columns
	if (!isSourceLeftPinned) {
		return !isTargetLeftPinned;
	}

	return true;
};
